export const head = <T>(array: T[]): T | undefined => array[0]
